import utils from '@/js/utils';
import MENU_USE_METRICS from '@/configs/menus/use_metrics.menu';
import { ROLES_LIST } from '@/js/constants';
export default [{
  path: '/use-metrics/summary',
  name: 'use_metrics_summary',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/SummaryPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/data-management',
  name: 'use_metrics_data_management',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/DataManagementPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/attributes',
  name: 'use_metrics_attributes',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/AttributesPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/audiences',
  name: 'use_metrics_audiences',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/AudiencesPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/insights',
  name: 'use_metrics_insights',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/InsightsPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/assets-corp',
  name: 'use_metrics_assets_corp',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/AssetsCorpPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/tables-government',
  name: 'use_metrics_tables_government',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/TablesGovernmentPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/quality-government',
  name: 'use_metrics_quality_government',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/QualityGovernmentPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/security-government',
  name: 'use_metrics_security_government',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/SecurityGovernmentPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/dashboard-government',
  name: 'use_metrics_dashboard_government',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/DashboardGovernmentPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}, {
  path: '/use-metrics/maturity-government',
  name: 'use_metrics_maturity_government',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/use-metrics/pages/MaturityGovernmentPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('use_metrics_summary', MENU_USE_METRICS)
  }
}];